import { action as apiAction } from 'api/Api'
import {
  setDueDate as setCardDueDate,
  setDueDateId as setCardDueDateId
} from '../redux/cards'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  id: number
}

export default (payload: Payload) => async dispatch => {
  const { id } = payload

  const optimisticAction = optimisticDispatch(dispatch, [
    setCardDueDate({
      id,
      dueDate: null
    }),
    setCardDueDateId({
      id,
      dueDateId: null
    })
  ])

  try {
    await apiAction('RemoveDueDate', {
      cardId: id
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}
